export default "__VITE_ASSET__IytzOnen__"